import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRouteLabel } from "../Layout/Sidebar";

/**
 * Updates document title and meta tags (og:title, description) based on current route.
 * Labels are read from Sidebar.js menu structure.
 */
const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = getRouteLabel(pathname);
    const description = getRouteLabel(pathname);

    document.title = title;

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
  }, [pathname]);

  return null;
};

export default PageMeta;
